export const footer = {
  footer: {
    background: "linear-gradient(116deg, #4D3F24 18.91%, #FFA800 117.63%)",
  },
  groupIcon: {
    display: "none",
  },
  socialMediaIcon: {
    display: "block",
  },
  socialMediaLabel: {
    display: "none",
  },
  sectionSocialMediaTitle: {
    display: "none",
  },
};
